class VisualEntities {
  #entities = {};

  set(key, value) {
    this.#entities[key] = value;
  }

  get(key) {
    return this.#entities[key];
  }

  delete(key) {
    delete this.#entities[key];
  }
}

const visualEntities = new VisualEntities();
export { VisualEntities, visualEntities };
